import standardDetailLayoutRoute from '@input-web/modules/standard/views/detail-layout/standard-detail-layout.route';
import { NavigateOptions, useNavigate, useParams } from '@tanstack/react-router';
import { useCallback } from 'react';

export default function useStandardDetailLayoutParams() {
  // #region Dependencies
  const navigate = useNavigate();
  const params = useParams({ from: standardDetailLayoutRoute.id, shouldThrow: false });
  // #endregion

  // #region Handlers
  const handleNavigate = useCallback(
    (partId: string, options?: NavigateOptions) =>
      navigate({
        from: standardDetailLayoutRoute.fullPath,
        params: { partId },
        search: true,
        state: true,
        ...options,
      }),
    [navigate],
  );
  // #endregion

  return { handleNavigate, params };
}
